module.exports = "<p>\r\n  payment works!\r\n</p>\r\n"